interface ExpertProfileIntroProps {
  photoSrc: string
  photoAlt: string
  name: string
  affiliation: string
  description: string
}

export default function ExpertProfileIntro({
  photoSrc,
  photoAlt,
  name,
  affiliation,
  description,
}: ExpertProfileIntroProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:mb-7 sm:flex-row sm:items-center">
      <div className="h-24 w-24 shrink-0 overflow-hidden rounded-full ring-2 ring-blue">
        <img
          src={photoSrc}
          alt={photoAlt}
          className="h-full w-full object-cover object-center"
          loading="lazy"
        />
      </div>

      <div>
        <p className="text-xl font-bold text-blue sm:text-2xl">{name}</p>
        <p className="mt-1 text-sm font-semibold text-text-secondary">{affiliation}</p>
        <p className="mt-2 text-sm text-text-secondary">{description}</p>
      </div>
    </div>
  )
}
